// -----------------------------------------
// Load Cart Drawer
// -----------------------------------------
function load_cart() {
  fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = "cart-drawer";
      const html = new DOMParser().parseFromString(responseText, "text/html");

      const destination = document.querySelector(".cart-sidebar");
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;

      // Item Remove
      document.querySelectorAll(".item-remove").forEach((cartRemove) => {
        const data_line = cartRemove.dataset.line;
        cartRemove.addEventListener("click", () => removeItem(data_line));
      });

      // Open Drawer
      document.querySelectorAll(".header-cart").forEach((cartButton) => {
        cartButton.addEventListener("click", () => {
          document.body.classList.add("open-drawer");
          document.body.classList.remove(
            "open-menu",
            "open-search",
            "open-sort",
            "open-filter"
          );
        });
      });

      // Close Drawer
      document
        .querySelectorAll(".overlay-box,.cart-drawer-close")
        .forEach((cartButton) => {
          cartButton.addEventListener("click", (e) => {
            e.preventDefault();
            document.body.classList.remove(
              "open-drawer",
              "open-menu",
              "open-search",
              "open-sort",
              "open-filter"
            );
          });
        });

      // Init cart components
      cartVariant();
      cartComplementary();
      cartAddons();
      cartmaintab();
      recentlyViewedProducts?.();

      // Update cart count
      fetch("/cart.js")
        .then((resp) => resp.json())
        .then((data) => {
          const cart_count = data.item_count;
          document.querySelector(".cart-count").innerHTML =
            cart_count > 0 ? cart_count : "";
        })
        .catch(console.error);
    });
    setTimeout(() => {
      ShippingCalculator();
    }, 1000);
}

load_cart();

// -----------------------------------------
// Remove Item
// -----------------------------------------
function removeItem(data_line) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ line: data_line, quantity: 0 }),
  })
    .then((response) => response.json())
    .then(() => load_cart())
    .catch((error) => console.error("Error:", error));
}

// -----------------------------------------
// Update Item
// -----------------------------------------
function updateItem(data_line, data_qty) {
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: data_line, quantity: data_qty }),
  })
    .then(() => {
      if (window.location.href.includes("/cart")) {
        window.location.href = "/cart";
      } else {
        load_cart();
        setTimeout(() => document.body.classList.add("open-drawer"), 500);
      }
    })
    .catch((error) => console.error("Error:", error));
}

// -----------------------------------------
// Quantity Selectors
// -----------------------------------------
function cartVariant() {
  document.querySelectorAll(".ci_plus").forEach((plus) => {
    plus.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const input = plus.closest(".ci_qtybox").querySelector(".cart_qty");
      input.value = parseInt(input.value) + 1;
      const minusBtn = plus.closest(".ci_qtybox").querySelector(".ci_minus");
      minusBtn.classList.remove("disabled");

      const new_line = plus.getAttribute("data-line-item");
      updateItem(new_line, input.value);
    });
  });

  document.querySelectorAll(".ci_minus").forEach((minus) => {
    minus.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      const input = minus.closest(".ci_qtybox").querySelector(".cart_qty");
      const currentQty = parseInt(input.value);
      const minQty = parseInt(input.getAttribute("min")) || 1;

      if (currentQty > minQty) {
        input.value = currentQty - 1;

        if (input.value <= minQty) {
          minus.classList.add("disabled");
        }

        const new_line = minus.getAttribute("data-line-item");
        updateItem(new_line, input.value);
      } else {
        minus.classList.add("disabled");
      }
    });

    const input = minus.closest(".ci_qtybox").querySelector(".cart_qty");
    const minQty = parseInt(input.getAttribute("min")) || 1;
    if (parseInt(input.value) <= minQty) {
      minus.classList.add("disabled");
    }
  });
}


// -----------------------------------------
// Cart Tabs
// -----------------------------------------
function cartmaintab() {
  const tabs = document.querySelectorAll(".chead-tab");
  const lists = document.querySelectorAll(".cart-tab-list");

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const id = tab.getAttribute("data-id");
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");

      lists.forEach((list) => list.classList.remove("active"));
      document.querySelector(`.cart-tab-list[data-id="${id}"]`)?.classList.add("active");
    });
  });
}

// -----------------------------------------
// Complementary Products
// -----------------------------------------
function cartComplementary() {
  if (!customElements.get("cart-complementary")) {
    customElements.define(
      "cart-complementary",
      class extends HTMLElement {
        constructor() {
          super();
          if ("requestIdleCallback" in window) {
            requestIdleCallback(this.init.bind(this), { timeout: 1500 });
          } else {
            FoxTheme?.Motion?.inView(this, this.init.bind(this), {
              margin: "0px 0px 400px 0px",
            });
          }
        }

        init() {
          fetch(this.dataset.url)
            .then((r) => r.text())
            .then((htmlTxt) => {
              const sectionHTML = new DOMParser()
                .parseFromString(htmlTxt, "text/html")
                .querySelector(".shopify-section");

              if (!sectionHTML) return;

              const recommendations = sectionHTML.querySelector("cart-complementary");
              if (recommendations && recommendations.innerHTML.trim()) {
                this.innerHTML = recommendations.innerHTML;
              }

              if (recommendations?.querySelector(".ra_product")) {
                this.dispatchEvent(new CustomEvent("recommendations:loaded"));
              } else {
                this.closest(".product__block")?.remove();
                this.dispatchEvent(new CustomEvent("recommendations:empty"));
              }

              initComplementarySwiper();
              recommendedProduct?.();
            })
            .catch(console.error);
        }
      }
    );
  }
}

function initComplementarySwiper() {
  if (document.querySelector(".cart-complementary-slider")) {
    new Swiper(".cart-complementary-slider", {
      slidesPerView: 1,
      spaceBetween: 10,
      grabCursor: true,
      navigation: {
        nextEl: ".comp-next",
        prevEl: ".comp-prev",
      },
    });
  }
}

document.addEventListener("cart:refresh", initComplementarySwiper);
document.addEventListener("DOMContentLoaded", initComplementarySwiper);

// -----------------------------------------
// Addons Drawer (Notes, Warranty, etc.)
// -----------------------------------------
function cartAddons() {
  const addonTabs = document.querySelectorAll(".cart-addons-tab");

  addonTabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = tab.getAttribute("aria-controls");
      const drawer = document.getElementById(targetId);

      document.querySelectorAll(".cart-addons-drawer").forEach((other) => {
        if (other.id !== targetId) {
          other.classList.remove("drawer--active");
          other.removeAttribute("open");
        }
      });

      const isOpen = drawer.classList.contains("drawer--active");
      if (isOpen) {
        closeAddonDrawer(drawer, tab);
      } else {
        openAddonDrawer(drawer, tab);
      }
    });
  });

  function openAddonDrawer(drawer, tab) {
    drawer.classList.add("drawer--active");
    drawer.style.maxHeight = drawer.scrollHeight + "px";
    drawer.setAttribute("open", "");
    tab.setAttribute("aria-expanded", "true");
  }

  function closeAddonDrawer(drawer, tab = null) {
    drawer.classList.remove("drawer--active");
    drawer.removeAttribute("open");
    drawer.style.maxHeight = "0px";
    if (tab) tab.setAttribute("aria-expanded", "false");
  }

  document.querySelectorAll(".cart-addons-drawer").forEach((drawer) => {
    const closeBtn = drawer.querySelector(".drawer__close-btn");
    const overlay = drawer.querySelector(".fixed-overlay");

    closeBtn?.addEventListener("click", (e) => {
      e.preventDefault();
      closeAddonDrawer(drawer);
    });

    overlay?.addEventListener("click", (e) => {
      e.preventDefault();
      closeAddonDrawer(drawer);
    });
  });

  // Cart Note Drawer
  const noteDrawer = document.querySelector("modal-component[id^='CartNote']");
  const noteTextarea = noteDrawer?.querySelector("textarea[name='note']");
  const noteApplyBtn = noteDrawer?.querySelector("button.btn--primary");

  if (noteDrawer && noteApplyBtn && noteTextarea) {
    noteApplyBtn.addEventListener("click", (e) => {
      e.preventDefault();
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: noteTextarea.value }),
      }).then(() => closeAddonDrawer(noteDrawer));
    });
  }
}

// -----------------------------------------
// Pure JS Custom Theme Utilities
// -----------------------------------------
(() => {
  const CustomTheme = {
    routes: {
      cart_update_url: "/cart/update.js",
      cart_url: "/cart",
      cart_json: "/cart.js",
    },

    utils: {
      fetchConfig(method = "POST", contentType = "application/json") {
        return {
          method,
          headers: { "Content-Type": contentType },
        };
      },

      debounce(fn, delay = 300) {
        let timer;
        return function (...args) {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), delay);
        };
      },

      tryParseJson(text) {
        try {
          return JSON.parse(text);
        } catch {
          return null;
        }
      },
    },

    publish(eventName, detail = {}) {
      document.dispatchEvent(new CustomEvent(eventName, { detail }));
    },
  };

  // Auto-Save Notes
  (function initOrderNoteSave() {
    const noteDrawer = document.querySelector("modal-component[id^='CartNote']");
    const noteTextarea = noteDrawer?.querySelector("textarea[name='note']");
    const noteApplyBtn = noteDrawer?.querySelector("button.btn--primary");

    if (noteDrawer && noteApplyBtn && noteTextarea) {
      noteApplyBtn.addEventListener("click", (e) => {
        e.preventDefault();
        fetch(CustomTheme.routes.cart_update_url, {
          ...CustomTheme.utils.fetchConfig("POST"),
          body: JSON.stringify({ note: noteTextarea.value }),
        })
          .then(() => typeof closeAddonDrawer === "function" && closeAddonDrawer(noteDrawer))
          .catch((err) => console.error("Order note save failed:", err));
      });
    }
  })();

  // <cart-note> element
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this._onChangeDebounced = CustomTheme.utils.debounce(this.onChange.bind(this), 300);
      this.addEventListener("change", this._onChangeDebounced);
    }

    onChange(event) {
      const value =
        event?.target?.value ||
        this.querySelector('textarea[name="note"]')?.value ||
        "";

      fetch(CustomTheme.routes.cart_update_url, {
        ...CustomTheme.utils.fetchConfig("POST"),
        body: JSON.stringify({ note: value }),
      })
        .then((r) => {
          if (!r.ok) throw new Error("Cart note update failed");
          return r.json?.() || {};
        })
        .then(() => CustomTheme.publish("cart:updated"))
        .catch((err) => console.error("Cart note update error:", err));
    }
  }

  customElements.define("cart-note", CartNote);
})();